import { supabase } from './supabase';

const BUCKET = 'episode-data';
const urlCache = new Map<string, string>();

export function publicFileUrl(storageRoot: string, fileName: string | null | undefined): string | null {
  if (!storageRoot || !fileName) return null;

  const cacheKey = `${storageRoot}/${fileName}`;
  if (urlCache.has(cacheKey)) {
    return urlCache.get(cacheKey)!;
  }

  const { data } = supabase.storage.from(BUCKET).getPublicUrl(cacheKey);
  const url = data?.publicUrl ?? null;

  if (url) {
    urlCache.set(cacheKey, url);
  }

  return url;
}
